// Shared region search — matches by region / country / ID / zone plus climate,
// live weather, organization membership and population thresholds. Used by both
// the Ctrl+F modal and the sidebar search box so they stay in sync.
export function searchRegions(regionsData, rawQuery, { organizationsCatalog, weatherData, limit = 20 } = {}) {
  const q = (rawQuery || '').trim().toLowerCase()
  if (!q || !regionsData?.features) return []

  // Numeric population query: "1000000", ">1M", "<500k", ">= 2 000 000".
  const popMatch = /^([<>]=?)?\s*([\d\s.,]+)\s*([km])?$/i.exec(q)
  let popOp = null; let popThreshold = null
  if (popMatch && /\d/.test(popMatch[2])) {
    popOp = popMatch[1] || '>='
    let n = parseFloat(popMatch[2].replace(/[\s,]/g, ''))
    const suffix = (popMatch[3] || '').toLowerCase()
    if (suffix === 'k') n *= 1e3
    else if (suffix === 'm') n *= 1e6
    popThreshold = n
  }
  const regionWeather = weatherData?.regions
  const out = []
  for (const f of regionsData.features) {
    if (out.length >= limit && popThreshold == null) break
    const p = f.properties
    const regionId = String(p.region_id || '')
    const orgNames = (p.organization_ids || [])
      .map((id) => organizationsCatalog?.[id]?.name?.toLowerCase())
      .filter(Boolean)
    const w = regionWeather?.[p.region_id] ?? regionWeather?.[String(p.region_id)]
    const weatherType = (w?.weather_type ?? p.weather_type ?? '').toLowerCase()

    let matchType = null
    if (regionId === q || regionId.includes(q)) matchType = 'ID'
    else if ((p.name || '').toLowerCase().includes(q)) matchType = 'Région'
    else if ((p.country_name || '').toLowerCase().includes(q)) matchType = 'Pays'
    else if ((p.geographical_area || '').toLowerCase().includes(q)) matchType = 'Zone'
    else if ((p.climate || '').toLowerCase().includes(q)) matchType = 'Climat'
    else if (weatherType && weatherType.includes(q)) matchType = 'Météo'
    else if (orgNames.some((n) => n.includes(q))) matchType = 'Organisation'
    else if (popThreshold != null && p.population > 0) {
      const pop = Number(p.population)
      const ok = popOp === '>' ? pop > popThreshold
        : popOp === '<' ? pop < popThreshold
        : popOp === '<=' ? pop <= popThreshold
        : pop >= popThreshold
      if (ok) matchType = 'Population'
    }

    if (matchType) out.push({ ...p, matchType })
  }
  if (popThreshold != null) out.sort((a, b) => (b.population || 0) - (a.population || 0))
  return out.slice(0, limit)
}
